export default "__VITE_ASSET__k7EfXS5K__"